/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */
/** @jsx jsx */

import { jsx } from '@emotion/react'

import { EuiButtonGroup, EuiFormRow, EuiText } from '@elastic/eui'

import { FormattedMessage } from '@modules/i18n'

export type AllRoleSelectorUiamProps = {
  allRole: boolean
  setAllRole: (value: boolean) => void
  replaceAllRoleAssignment: () => void
}

const AllRoleSelectorUiam = ({
  allRole,
  setAllRole,
  replaceAllRoleAssignment,
}: AllRoleSelectorUiamProps): JSX.Element => (
  <EuiFormRow fullWidth={false} style={{ maxWidth: '29rem' }}>
    <EuiButtonGroup
      options={[
        {
          label: (
            <EuiText size='s'>
              <FormattedMessage
                id='roles-assignments.assign.all.description'
                defaultMessage='Assign to all'
              />
            </EuiText>
          ),
          id: 'all',
        },
        {
          label: (
            <EuiText size='s'>
              <FormattedMessage
                id='roles-assignments.assign.each.description'
                defaultMessage='Assign for each resource'
              />
            </EuiText>
          ),
          id: 'each',
        },
      ]}
      idSelected={allRole ? 'all' : 'each'}
      onChange={(idSelected) => {
        setAllRole(idSelected === 'all')

        if (idSelected === 'each') {
          replaceAllRoleAssignment()
        }
      }}
      legend='All Role Selection'
      isFullWidth={true}
    />
  </EuiFormRow>
)

export default AllRoleSelectorUiam
